/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowForward = createReactComponent("arrow-forward", "IconArrowForward", [
  ["path", { d: "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1", key: "svg-0" }]
]);

export { IconArrowForward as default };
//# sourceMappingURL=IconArrowForward.js.map
